import Icon from "../Icon/Icon"
import HorizontalField from "../HorizontalField/HorizontalField"
import React from "react"
import classNames from "classnames"

export default function EvaluationType({fieldClassName}: {fieldClassName?: string}) {
	return (
		<HorizontalField label={"Evaluation type"} fieldClassName={classNames("evaluation-type", fieldClassName)}>
			<div className="flex-container justify-content-start align-items-center">
				<div className="icon-wrapper flex-container justify-content-center align-items-center">
					<Icon icon="user-geometric-action-check-approve" className="evaluation-type-icon" size={12} />
				</div>
				<input type="text" readOnly value={"Pre-Approved"} className="input is-static" />
			</div>
		</HorizontalField>
	)
}
